import React from "react";
import { icons } from "../../assets/icons";
import { imgs } from "../../assets/imgs";
import { isIOS, isMacOs, isWindows } from "react-device-detect";

export const DialogBar = ({ dialog, callback, percentage, whitImg = false }) => {
	const goToFullScrenn = () => {
		if (!isIOS && !isWindows && !isMacOs) {
			document.body.requestFullscreen();
		}
	};
	return (
		<div className="fixed bottom-0 z-40 w-full h-[105px] md:h-[170px] px-3 md:px-4 pb-3 md:pb-4">
			<div className="flex w-full h-full bg-[#282828]  px-4 rounded-lg animate__animated  animate__fadeIn">
				{whitImg && (
					<div className="w-[151px] h-full flex justify-start md:justify-center items-center">
						<div className="w-[70px] md:w-[104px] h-[70px] md:h-[104px] bg-white rounded-2xl">
							<img src={imgs.icon_andatti} className="w-full h-full object-cover" alt="" />
						</div>
					</div>
				)}
				<div className="w-full h-full">
					<div className="w-full h-2/6  flex justify-between items-center">
						<p className="text-sm md:text-xl font-bold text-white">Datti Andati</p>
						<div className="flex">
							<p className="text-[#A7C1FF] font-semibold text-8 md:text-sm pr-2">Ver transcripcion</p>
							<img src={icons.linkOpen} alt="" />
						</div>
					</div>
					<div
						onClick={() => {
							goToFullScrenn();
							callback();
						}}
						className="w-full h-3/6 flex items-center justify-between cursor-pointer"
					>
						<p className="text-white font-semibold text-xs md:text-base w-10/12">{dialog}</p>
						<img src={icons.nextArrow} className="w-8 md:w-11 h-8 md:h-11" alt="" />
					</div>
					<div className="w-full h-1/6 flex justify-center items-center">
						<div className="relative w-full bg-[#E6E6E6] h-2">
							<div className="absolute h-full bg-[#FFC427]" style={{ width: percentage }}></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
